import axios from 'axios'
import MockAdapter from 'axios-mock-adapter'
import { routes } from './routes.ts'

const apiURL = import.meta.env.VITE_APP_API_URL
const apiWalletURL = import.meta.env.VITE_APP_WALLET_API_URL
const apiManagementURL = import.meta.env.VITE_APP_MANAGEMENT_API_URL
const apiMarketplaceURL = import.meta.env.VITE_APP_MARKETPLACE_API_URL
const apiVersion = import.meta.env.VITE_APP_API_VERSION
const apiWalletVersion = import.meta.env.VITE_APP_WALLET_API_VERSION

export const protectedBaseURL = `${apiURL}/api/${apiVersion}`
export const unProtectedBaseURL = `${apiURL}/${apiVersion}`

export const walletBaseURL = `${apiWalletURL}/api/${apiWalletVersion}`
export const managementBaseURL = `${apiManagementURL}/api`
export const marketplaceBaseURL = `${apiMarketplaceURL}/api/marketplace`

const methods = {
  GET: 'onGet',
  POST: 'onPost',
  PUT: 'onPut',
  DELETE: 'onDelete',
  ANY: 'onAny'
}

export const status = {
  ok: 200,
  error: 400,
  unauthorized: 401,
  forbidden: 403,
  notFound: 404,
  serverConflict: 409,
  serverError: 500
}

const mockAxiosInENV = (env: string) => {
  if (process.env.NODE_ENV !== env) return
  console.log('%c mocking axios requests', 'background: #222; color: #bada55')
  const mock = new MockAdapter(axios)
  routes.forEach((route) => {
    const { method, path, reply } = route
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const mockMethod = methods[method] || 'onAny'
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    mock[mockMethod](protectedBaseURL + path).reply(reply)
    console.log(`${method} - ${protectedBaseURL + path}`)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    mock[mockMethod](unProtectedBaseURL + path).reply(reply)
    console.log(`${method} - ${unProtectedBaseURL + path}`)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    mock[mockMethod](walletBaseURL + path).reply(reply)
    console.log(`${method} - ${walletBaseURL + path}`)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    mock[mockMethod](managementBaseURL + path).reply(reply)
    console.log(`${method} - ${managementBaseURL + path}`)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    mock[mockMethod](marketplaceBaseURL + path).reply(reply)
    console.log(`${method} - ${marketplaceBaseURL + path}`)
  })
}

export default mockAxiosInENV
